import { supabase } from './supabase';

const PUBLIC_FILE_BASE = import.meta.env.VITE_PUBLIC_FILE_BASE;

if (!PUBLIC_FILE_BASE) {
  // 不中断运行，但给出明确提示，便于快速定位
  // 建议在 .env 中配置 VITE_PUBLIC_FILE_BASE
  console.warn('VITE_PUBLIC_FILE_BASE is not set. Public URL generation may fail.');
}

const THUMBNAIL_PREFIX = 'thumbnails/';

export const uploadToR2 = async (file: File, key: string) => {
  try {
    console.log('Starting upload via presigned URL:', { key, type: file.type });

    // 1) 获取预签名上传 URL（由 Edge Function 生成）
    const { data, error } = await supabase.functions.invoke('r2-storage', {
      body: {
        action: 'presignUpload',
        key,
        contentType: file.type || 'application/octet-stream',
        expiresIn: 3600,
      },
    });

    if (error) throw error;
    const url = (data as any)?.url as string;
    if (!url) throw new Error('Failed to get presigned upload URL');

    // 2) 直接 PUT 文件到预签名 URL
    const putResp = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type || 'application/octet-stream',
      },
      body: file,
    });
    if (!putResp.ok) {
      const text = await putResp.text().catch(() => '');
      throw new Error(`Upload failed: ${putResp.status} ${putResp.statusText} ${text}`);
    }

    return `${PUBLIC_FILE_BASE || ''}/${key}`.replace(/\/+/, '/');
  } catch (error) {
    console.error('Error uploading via presigned URL:', error);
    throw error;
  }
};

export const deleteFromR2 = async (key: string) => {
  try {
    const { error } = await supabase.functions.invoke('r2-storage', {
      body: {
        action: 'deleteObject',
        key,
      },
    });
    if (error) throw error;
  } catch (error) {
    console.error('Error deleting object via function:', error);
    throw error;
  }
};

export const getSignedUrl = async (key: string, expiresIn = 3600) => {
  try {
    const { data, error } = await supabase.functions.invoke('r2-storage', {
      body: {
        action: 'signedUrl',
        key,
        expiresIn,
      },
    });
    if (error) throw error;
    const url = (data as any)?.url as string;
    if (!url) throw new Error('Failed to get signed URL');
    return url;
  } catch (error) {
    console.error('Error generating signed URL via function:', error);
    throw error;
  }
};

export const getPublicUrl = async (key: string): Promise<string> => {
  if (!key) throw new Error('Storage key is required');
  if (!PUBLIC_FILE_BASE) throw new Error('VITE_PUBLIC_FILE_BASE is not configured');
  return `${PUBLIC_FILE_BASE}/${key}`;
};

export const getThumbnailUrl = async (key: string): Promise<string> => {
  if (!PUBLIC_FILE_BASE) throw new Error('VITE_PUBLIC_FILE_BASE is not configured');
  const thumbnailKey = `${THUMBNAIL_PREFIX}${key}`;
  return `${PUBLIC_FILE_BASE}/${thumbnailKey}`;
};